var _path, _path2, _g, _path3, _g2, _path4, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEyeReveal = function SvgEyeReveal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.134 10.118a.62.62 0 0 1-.442-.183A3.271 3.271 0 0 1 9 4.356c.866 0 1.706.35 2.305.961a.627.627 0 0 1-.89.88A1.987 1.987 0 0 0 9 5.609a2.018 2.018 0 0 0-1.424 3.44.628.628 0 0 1-.442 1.07ZM9.473 10.849a.626.626 0 0 1-.111-1.244 2.01 2.01 0 0 0 1.61-1.618.628.628 0 0 1 .726-.506c.34.061.566.387.505.728a3.27 3.27 0 0 1-2.618 2.63.645.645 0 0 1-.112.01Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "eye_reveal_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 13
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.667.933h13.405v11.78H.667V.933Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#eye_reveal_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.545 12.713a.628.628 0 0 1-.385-.133C2.75 11.47 1.56 9.843.718 7.876a.625.625 0 0 1 0-.496c.85-1.975 2.049-3.61 3.466-4.727 2.888-2.293 6.733-2.3 9.65.016a.625.625 0 1 1-.776.983c-2.471-1.962-5.655-1.955-8.1-.015-1.197.944-2.224 2.32-2.983 3.992.751 1.663 1.77 3.03 2.957 3.965a.628.628 0 0 1-.387 1.12Z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "eye_reveal_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 4,
    width: 12,
    height: 11
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.265 4.373h11.068v9.984H6.265V4.373Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#eye_reveal_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 14.357a7.29 7.29 0 0 1-2.307-.377.628.628 0 0 1 .395-1.19A6.022 6.022 0 0 0 9 13.103c2.857 0 5.468-2.04 7.025-5.475a12.124 12.124 0 0 0-1.317-2.252.625.625 0 1 1 .998-.754 13.497 13.497 0 0 1 1.576 2.757c.069.158.069.339 0 .497-1.747 4.058-4.843 6.48-8.282 6.48Z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "eye_reveal_svg__c",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 16,
    height: 15
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.803.411h14.395v14.434H1.803V.41Z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#eye_reveal_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.428 14.845a.627.627 0 0 1-.442-1.07L15.131.595a.623.623 0 0 1 .883 0 .628.628 0 0 1 0 .886L2.87 14.66a.619.619 0 0 1-.441.184Z"
  }))));
};
export default SvgEyeReveal;